export default {"src":"/_next/static/media/goat-spins-banner-3-mob.e45dc3bb.svg","height":563,"width":372,"blurWidth":0,"blurHeight":0};